import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface PhotoCamera extends SVGProps<SVGSVGElement> {
  label?: string
}

const PhotoCamera: React.FC<PhotoCamera> = ({
  label = 'photoCamera',
  ...restProps
}) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="photo-camera-svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.27924 6L6.59547 5.05132C7.00381 3.82629 8.15023 3 9.44152 3H14.5585C15.8498 3 16.9962 3.82629 17.4045 5.05132L17.7208 6H19C20.6569 6 22 7.34315 22 9V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V9C2 7.34315 3.34315 6 5 6H6.27924ZM12 18C9.23858 18 7 15.7614 7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13C17 15.7614 14.7614 18 12 18ZM12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default PhotoCamera
